import { ReactElement } from 'react'
import fs from 'fs'
import { InferGetStaticPropsType } from 'next'
import path from 'path'

import Meta from '@/components/base/Meta'
import Builder from '@/components/layout/Builder'
import Layout from '@/components/layout/Layout'
import usePagePrecache from '@/hooks/usePagePrecache'
import { axiosInstance as axios } from '@/base/axios'

import { WPPageData } from '@/types'

export default function Home(
  pageData: InferGetStaticPropsType<typeof getStaticProps>
) {
  usePagePrecache(true, [])
  return (
    <>
      <div data-builder className="relative z-10">
        <Builder pageData={pageData} />
      </div>
    </>
  )
}

Home.getLayout = function getLayout(page: ReactElement, props: WPPageData) {
  return (
    <Layout pageData={props}>
      <Meta pageData={props} />
      {page}
    </Layout>
  )
}

export async function getStaticProps() {
  // Ambiente di sviluppo (locale) - usa sempre il file statico
  // if (process.env.NODE_ENV === 'development') {
  console.log('Using local JSON file in development environment')
  const filePath = path.join(process.cwd(), '/data/index.json')
  const data = JSON.parse(fs.readFileSync(filePath, 'utf-8'))

  // se in data è presente un form_section con form_id allora esegui una chiamata API per ottenere i campi del form
  const formSection = data.acf.builder.find(
    (section: any) => section.acf_fc_layout === 'form'
  )

  if (formSection?.form_id) {
    try {
      const res = await axios.get(
        `${process.env.NEXT_PUBLIC_ADMIN_BASE_URL}/${formSection.form_id}`
      )
      formSection.form = res.data
    } catch (error) {
      console.error('Error fetching form data:', error)
    }
  }
  return { props: data }
  // }

  // Ambiente di produzione (remoto) - prova a usare Edge Config
  // try {
  //   if (process.env.EDGE_CONFIG && process.env.EDGE_NODE_ID) {
  //     console.log('Using Vercel Edge Config in production environment')
  //     const { createClient } = await import('@vercel/edge-config')
  //     const client = createClient(process.env.EDGE_CONFIG)
  //     const data = await client.get(process.env.EDGE_NODE_ID)
  //     if (data) {
  //       return { props: data }
  //     }
  //   }
  // } catch (error) {
  //   console.error('Edge Config error:', error)
  // }

  // // Fallback alla lettura del file locale anche in produzione se Edge Config fallisce
  // console.log('Falling back to local JSON file')
  // const filePath = path.join(process.cwd(), '/data/index.json')
  // const data = JSON.parse(fs.readFileSync(filePath, 'utf-8'))
  // return { props: data }
}
